import "../App.css";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";

import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";
const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};

const Games = () => {
  const { hash } = useLocation();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300); // Show button after scrolling down 300px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  function importAll(r) {
    let images = {};
    r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  const images = importAll(require.context('../imgs/products', false, /\.(png|jpe?g|svg)$/));
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun: Our Games</title>
        <meta name="title" content="Heartland Fun: Our Games" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: Our Games" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/games" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <FadeInTitle>
        ALL GAMES
      </FadeInTitle>
      <p className="Blue InfoText Titillium Center FadeIn">
        At Heartland Fun, we work directly with you, whether you're interested in adding a single claw machine to your business or setting up an entire arcade. Our new and unique arcade machines are available at a competitive market price. We're now offering our machines for use at your location without any upfront cost, provided that your location meets our foot traffic requirements. We determine our percentage based on the foot traffic of your store. Therefore, don't hesitate to contact us today. We'd be thrilled to collaborate with you and your company.
      </p>
      <br></br>
      <a href="tel:7858137921" className="Button Titillium Center">
        Talk to an Arcade Specialist Now to Buy a Game
      </a>
      <div className="Brake" id="RedemptionGames"></div>
      <FadeInTitle >
        Redemption Games
      </FadeInTitle>
      <div className="Table MakeWide Center">
        <div className="Container">
          <img alt="Arcade Game" src={images['rainbowhoops.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=rainbowHoops" className="SmallButton">Rainbow Hoops</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['sharkpark.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=sharkPark" className="SmallButton">Shark Park</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['oceanparty.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=OceanParty" className="SmallButton">Ocean Party</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['crazykitten.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=crazyKitten" className="SmallButton">Crazy Kitten</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['jungleparty.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=jungleParty" className="SmallButton">Jungle Party</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['firewall.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=firewall" className="SmallButton">Firewall</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['soccerstars.png']} className="ProductHolder"></img>
          <a href="/product?id=soccerStars" className="SmallButton">Soccer Stars</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['fastfood.png']} className="ProductHolder"></img>
          <a href="/product?id=fastFoodFrenzy" className="SmallButton">Fast Food Frenzy</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['jungleparty.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=jungleHockey" className="SmallButton">Jungle Hockey</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['solarstorm.png']} className="ProductHolder"></img>
          <a href="/product?id=solarStorm" className="SmallButton">Solar Storm</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['boxerkick.png']} className="ProductHolder"></img>
          <a href="/product?id=boxerKick" className="SmallButton">Boxer/Kick</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['boxer.png']} className="ProductHolder"></img>
          <a href="/product?id=boxer" className="SmallButton">Boxer</a>
        </div>
      </div>
      <div className="Brake" id="KiddieRides"></div>
      <FadeInTitle >
        Kiddie Rides
      </FadeInTitle>
      <div className="Table MakeWide Center">
        <div className="Container">
          <img alt="Arcade Game" src={images['pipicar.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=pipiCar" className="SmallButton">PiPi Car</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['minibus.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=miniBus" className="SmallButton">Mini Bus</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['bearseasaw.png']} className="ProductHolder"></img>
          <a href="/product?id=bearSeasaw" className="SmallButton">Bear-Seasaw</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['topgun2.png']} className="ProductHolder"></img>
          <a href="/product?id=topGun2" className="SmallButton">Top Gun 2</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['minisub.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=miniSubmarine" className="SmallButton">Mini Submarine</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['pirateship.png']} className="ProductHolder"></img>
          <a href="/product?id=pirateShip" className="SmallButton">Pirate Ship</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['bigfish.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=bigFish" className="SmallButton">Big Fish</a>
        </div>
      </div>
      <div className="Brake" id="ClawMachines"></div>
      <FadeInTitle >
        Claw Machines
      </FadeInTitle>
      <div className="Table MakeWide Center">
        <div className="Container">
          <img alt="Arcade Game" src={images['mukocut.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=mukoCut" className="SmallButton">Muko-Cut</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['tideplayer.png']} className="ProductHolder"></img>
          <a href="/product?id=tidePlayer" className="SmallButton">Tide Player</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['joyplayer.png']} className="ProductHolder"></img>
          <a href="/product?id=joyPlayer" className="SmallButton">Joy Player (Three lights avalible)</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['tide.png']} className="ProductHolder"></img>
          <a href="/product?id=tide2Player" className="SmallButton">Tide 2 Player</a>
        </div>
        <div className="Container">
          <img alt="Arcade Game" src={images['anime4player.jpeg']} className="ProductHolder"></img>
          <a href="/product?id=anime4Player" className="SmallButton">Anime 4 Player</a>
        </div>
      </div>
      <div className="Brake" id="CoinDispensers"></div>
      <FadeInTitle >
        Coin Dispensers
      </FadeInTitle>
      <div className="Table MakeWide Center">
        <div className="Container">
          <img alt="Arcade Coin Dispencer" src={images['coins.png']} className="ProductHolder"></img>
          <a href="/product?id=arcadeCoinDispencer" className="SmallButton">AC101</a>
        </div>
      </div>
      {showButton && (
        <button className="ToTheTop"
          onClick={scrollToTop}
        >
          Back to Top
        </button>
      )}
      <Footer></Footer>
    </div>
  );
};

export default Games;